import { Button } from "@/components/ui/button";
import AnimatedGradientBackground from "@/components/layout/animated-background";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

// Headline + CTA button — more compact now that the AI chat has its own section
// Background provided by wrapper in RedesignedHero
export const FinalCTAContent = () => {
  return (
    <div className="relative z-10 pt-20 sm:pt-24 pb-12 mx-auto max-w-7xl px-6 lg:px-8 text-center">
      <h2 className="mx-auto max-w-4xl mb-6 gradient-text-auth">
        <span className="whitespace-nowrap">Stop Juggling Tools.</span>
        <br />
        Start Growing.
      </h2>

      <p className="mx-auto mt-4 max-w-2xl text-lg sm:text-xl leading-relaxed text-muted-foreground">
        One platform for scheduling, payroll, customer loyalty, and analytics.
      </p>

      <div className="mt-10 flex items-center justify-center">
        <Button
          size="lg"
          className="font-semibold shadow-lg group bg-primary hover:bg-primary/90"
          asChild
        >
          <Link to="/pricing">
            See pricing
            <ArrowRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </div>
    </div>
  );
};

// Trust indicators
// Background provided by wrapper in RedesignedHero
export const FinalCTATrust = () => (
  <div className="relative z-10 pb-16 sm:pb-20 flex flex-wrap justify-center items-center gap-6 sm:gap-10 pt-4">
    <div className="flex items-center gap-2.5">
      <div className="w-1.5 h-1.5 rounded-full bg-primary shadow-sm shadow-primary/50" />
      <span className="text-sm font-medium text-foreground">No credit card required</span>
    </div>
    <div className="flex items-center gap-2.5">
      <div className="w-1.5 h-1.5 rounded-full bg-grow shadow-sm shadow-grow/50" />
      <span className="text-sm font-medium text-foreground">Free plan to start</span>
    </div>
    <div className="flex items-center gap-2.5">
      <div className="w-1.5 h-1.5 rounded-full bg-secondary shadow-sm shadow-secondary/50" />
      <span className="text-sm font-medium text-foreground">Cancel anytime</span>
    </div>
  </div>
);

export const FinalCTASection = () => (
  <div className="relative">
    <AnimatedGradientBackground orbs="none" />
    <div id="contact" data-showable="contact">
      <FinalCTAContent />
    </div>
    <FinalCTATrust />
  </div>
);
